import React from 'react';
import CityPage from '../CityPage/CityPage';
import image from './Brockville.jpeg';

const BrockvillePage = () => (
  <CityPage
    city="Brockville"
    region="Ontario"
    country="Canada"
    countryCode="CA"
    routePath="/brockville"
    currentPage="BrockvillePage"
    image={image}
    imageAlt="Boat rentals in Brockville, Ontario in the heart of the Thousand Islands"
    intro="Brockville sits on the St. Lawrence River in the heart of the Thousand Islands — one of the most famous boating destinations in Canada. WetRentals connects you with local hosts offering Sea-Doos, pontoons, fishing boats and more."
    sections={[
      {
        heading: 'Where to boat in Brockville',
        body:
          'Launch right into the St. Lawrence and explore the Thousand Islands. Popular destinations include Blockhouse Island, Centeen Park, and the islands stretching east toward Mallorytown Landing.',
      },
      {
        heading: 'What you can rent in Brockville',
        body:
          'Sea-Doo and Jet Ski rentals, pontoon boats, fishing boats for bass, pike and walleye, plus kayaks and paddleboards for shoreline exploring.',
      },
      {
        heading: 'Why book with WetRentals in Brockville',
        body:
          "WetRentals is Canada's largest peer-to-peer boat rental platform. Every booking includes safety equipment, instant confirmation, host messaging and a flexible cancellation policy.",
      },
    ]}
    searchUrl="/s?address=Brockville%2C%20Ontario%2C%20Canada&bounds=44.85%2C-75.30%2C44.30%2C-76.30&mapSearch=true"
    searchLabel="Browse all boat rentals in Brockville"
    showMembershipBanner
  />
);

export default BrockvillePage;
